import type { Dictionary } from "./es";

const en: Dictionary = {
  common: {
    search: "Search...",
    export: "Export",
    columns: "Columns",
    all: "All",
    cancel: "Cancel",
    save: "Save",
    saveChanges: "Save changes",
    discardChangesTitle: "Discard changes?",
    discardChangesDesc: "You have unsaved changes. If you leave now they will be lost.",
    discard: "Discard",
    keepEditing: "Keep editing",
    noResultsFor: "No results for",
    clearFilters: "Clear filters",
    loading: "Loading...",
    backToHome: "Back to home",
    viewAll: "View all",
    actions: "Actions",
    edit: "Edit",
    view: "View detail",
    delete: "Delete",
    new: "New",
    status: "Status",
    date: "Date",
    client: "Client",
    confirm: "Confirm",
    close: "Close",
    emptyCell: "-",
    moreOptions: "More options",
    resumen: "Summary",
    switchToDarkMode: "Switch to dark mode",
    switchToLightMode: "Switch to light mode",
    logout: "Log out",
    logoutConfirmTitle: "Log out?",
    logoutConfirmText: "You are about to leave the intranet. Do you want to continue?",
    language: "Language",
    appearance: "Appearance",
    appearanceSystem: "System",
    appearanceLight: "Light",
    appearanceDark: "Dark",
    myAccount: "My account",
    notifications: "Notifications",
    role: "Role",
    collapseMenu: "Collapse menu",
    expandMenu: "Expand menu",
  },
  status: {
    "sin-iniciar": "Not started",
    "en-desarrollo": "In progress",
    finalizada: "Completed",
    liquidada: "Settled",
    anulada: "Cancelled",
    "por-liquidar": "Pending settlement",
    pendiente: "Pending",
    activo: "Active",
    inactivo: "Inactive",
    disponible: "Available",
    "stock-bajo": "Low stock",
    "sin-stock": "Out of stock",
    normal: "Normal",
    atraso: "Late",
    ausencia: "Absence",
    incompleta: "Incomplete",
    "fin-de-semana": "Weekend",
  },
  nav: {
    groupOperacion: "Operations",
    groupInventario: "Inventory",
    groupPersonal: "Personnel",
    groupRecursos: "Inventory",
    groupPersonas: "Personnel",
    groupAdministracion: "Administration",
    dashboard: "Dashboard",
    ordenes: "Service Orders",
    liquidacion: "Settlement",
    bodega: "Warehouse",
    proveedores: "Suppliers",
    asistencia: "Attendance",
    trabajadores: "Workers",
    clientes: "Clients",
    perfiles: "Profiles",
    configuracion: "Settings",
  },
  topbar: {
    searchPlaceholder: "Search the intranet...",
    notifications: "Notifications",
  },
  emptyStates: {
    noData: "There are no records to show",
    noResults: "No results",
    createAction: "Create the first one",
  },
  datos: {
    guardando: "Saving…",
    guardado: "Saved",
    errorGuardar: "Couldn't save. Retrying…",
    conflicto: "Someone else changed this at the same time; their version was loaded.",
    numeroCambiado: "That order number already existed; the next available one was assigned.",
    cerrar: "Dismiss",
  },
  login: {
    welcomeTitle: "SEAELEC intranet",
    subtitle: "Sign in with your company Google account",
    googleSignIn: "Sign in with Google",
    orDivider: "or",
    rutToggle: "Sign in with RUT and password",
    rutHint: "For accounts without a company Google email",
    googleOnlyNote: "Only company Google accounts that have been given access to the intranet can sign in.",
    googleErrorTitle: "Couldn't sign in with Google",
    googleErrorCancelado: "Google sign-in was cancelled. You can try again.",
    googleErrorSinAlta: "Your Google account doesn't have access to the intranet. Ask an administrator to add you.",
    googleErrorDominio: "Use your company Google account; personal accounts don't have access.",
    googleErrorInactivo: "Your user is deactivated. Contact an administrator.",
    googleErrorFallo: "Something went wrong verifying your account. Please try again in a few minutes.",
    rutLabel: "RUT (National ID)",
    rutPlaceholder: "12.345.678-9",
    rutInvalid: "Check the RUT: it is not valid",
    required: "Fill in this field",
    passwordLabel: "Password",
    passwordPlaceholder: "Enter your password",
    showPassword: "Show password",
    hidePassword: "Hide password",
    forgotPassword: "Forgot your password?",
    signIn: "Sign in",
    signingIn: "Signing in…",
    invalidCredentials: "The RUT or password does not match. Check both and try again.",
    supportQuestion: "Need technical assistance?",
    copyright: "© 2026 SEAELEC SpA. All rights reserved.",
    languageSpanish: "Español",
    languageEnglish: "English",
    languageLabel: "Language",
    logoAlt: "SEAELEC",

    forgotTitle: "Recover password",
    forgotSubtitle: "Enter your RUT and we will email you a link to reset your password",
    sendInstructions: "Send instructions",
    sending: "Sending…",
    backToLogin: "Back to sign in",

    checkEmailTitle: "Check your email",
    checkEmailText:
      "If the RUT has an account, we sent an email with a link to reset your password",

    newPasswordTitle: "New password",
    newPasswordSubtitle: "Use at least 8 characters",
    newPasswordLabel: "New password",
    confirmPasswordLabel: "Confirm password",
    errorMismatch: "The passwords do not match",
    errorLength: "Use at least 8 characters",
    resetButton: "Reset password",
    resetting: "Resetting…",

    successTitle: "Password updated",
    successText: "You can now sign in with your new password",
    goToLogin: "Go to sign in",

    errorTitle: "This link is no longer valid",
    errorText: "The password reset link expired or was already used. Request a new one.",
    requestNewLink: "Request new link",

    demoSimTitle: "Demo: open the email link",
    demoSimValid: "Valid link",
    demoSimExpired: "Expired link",
  },
};

export default en;
